import { z } from 'zod';

// Note: at the time of adding TaxDetails, there's no information about how it will be used or related to escrow settings / properties
export const TaxDetails = z.object({
  taxExempt: z.boolean().optional(),
  backupWithholdingRequired: z.boolean().optional(),
  backupWithholdingAmount: z.number().nonnegative().optional(),
});
export type TaxDetails = z.infer<typeof TaxDetails>;
